"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
var utils_1 = require("../utils");
// import {BigInteger} from 'big-integer';
var dcorejs_lib_1 = require("dcorejs-lib");
var UtilsError;
(function (UtilsError) {
    UtilsError["wrong_private_key"] = "wrong_private_key";
})(UtilsError = exports.UtilsError || (exports.UtilsError = {}));
/**
 * PKI private key
 */
var KeyPrivate = /** @class */ (function () {
    function KeyPrivate(privateKey) {
        this._privateKey = {};
        this._privateKey = privateKey;
    }
    /**
     * Create KeyPrivate from brain key.
     *
     * @param {string} brainKey     Brain key to generate private key from.
     * @param {number} sequence     Sequence number, for generating derived private key
     * @returns {KeyPrivate}        KeyPrivate instance.
     */
    KeyPrivate.fromBrainKey = function (brainKey, sequence) {
        if (sequence === void 0) { sequence = 0; }
        var pKey = helpers_1.dcorejs_lib.key.get_brainPrivateKey(brainKey, sequence);
        return new KeyPrivate(pKey);
    };
    /**
     * Create KeyPrivate from WIF/hex format of private key.
     * @param {string} privateKeyWif    Private key in WIF(hex) (Wallet Import Format) format.
     * @returns {KeyPrivate}            KeyPrivate instance.
     */
    KeyPrivate.fromWif = function (privateKeyWif) {
        var pKey = helpers_1.dcorejs_lib.PrivateKey.fromWif(privateKeyWif);
        return new KeyPrivate(pKey);
    };
    Object.defineProperty(KeyPrivate.prototype, "key", {
        /**
         * Raw representation of key for dcorejs_libjs
         * library purposes.
         * @return {any}
         */
        get: function () {
            return this._privateKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyPrivate.prototype, "stringKey", {
        /**
         * WIF format string representation of key
         * @return {string}
         */
        get: function () {
            return this._privateKey.toWif();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get public key for private key.
     * @returns {KeyPublic}     KeyPublic instance.
     */
    KeyPrivate.prototype.getPublicKey = function () {
        return new KeyPublic(this._privateKey.toPublicKey());
    };
    return KeyPrivate;
}());
exports.KeyPrivate = KeyPrivate;
/**
 * PKI public key
 */
var KeyPublic = /** @class */ (function () {
    function KeyPublic(publicKey) {
        this._publicKey = new dcorejs_lib_1.PublicKey();
        this._publicKey = publicKey;
    }
    Object.defineProperty(KeyPublic, "empty", {
        get: function () {
            return 'DCT1111111111111111111111111111111114T1Anm';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Create KeyPublic object from public key string.
     * @param {string} publicString     Public key string.
     * @returns {KeyPublic}             KeyPublic instance.
     */
    KeyPublic.fromString = function (publicString) {
        var pubKey = helpers_1.dcorejs_lib.PublicKey.fromPublicKeyString(publicString);
        return new KeyPublic(pubKey);
    };
    /**
     * Create KeyPublic from KeyPrivate object.
     * @param {KeyPrivate} privateKey   KeyPrivate object.
     * @returns {KeyPublic}             KeyPublic instance.
     */
    KeyPublic.fromPrivateKey = function (privateKey) {
        var publicKey = privateKey.key.toPublicKey();
        return new KeyPublic(publicKey);
    };
    Object.defineProperty(KeyPublic.prototype, "key", {
        /**
         * Raw representation of key for dcorejs_libjs
         * library purposes.
         * @return {any}
         */
        get: function () {
            return this._publicKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyPublic.prototype, "stringKey", {
        /**
         * String representation of key
         * @return {string}     String public key.
         */
        get: function () {
            return this._publicKey.toString();
        },
        enumerable: true,
        configurable: true
    });
    return KeyPublic;
}());
exports.KeyPublic = KeyPublic;
var ElGamalKeys = /** @class */ (function () {
    function ElGamalKeys(elGPrivateKey, elGPublicKey) {
        this._publicKey = '';
        this._privateKey = '';
        this._privateKey = elGPrivateKey;
        this._publicKey = elGPublicKey;
    }
    Object.defineProperty(ElGamalKeys.prototype, "privateKey", {
        get: function () {
            return this._privateKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElGamalKeys.prototype, "publicKey", {
        get: function () {
            return this._publicKey;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Generate ElGamalKeys object from public key WIF.
     * @param {string} privateKey       Private key in WIF(hex) (Wallet Import Format) format
     * @returns {ElGamalKeys}           ElGamalKeys instance.
     */
    ElGamalKeys.generate = function (privateKey) {
        var elGPrivate = utils_1.Utils.elGamalPrivate(privateKey);
        var elGPub = utils_1.Utils.elGamalPublic(elGPrivate);
        return new ElGamalKeys(elGPrivate, elGPub);
    };
    return ElGamalKeys;
}());
exports.ElGamalKeys = ElGamalKeys;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/utils.js
// module id = 33
// module chunks = 0